import { useEffect, useState } from "react";
import style from "./toast.module.css";
import { renderInPortal, usePortal } from "frontend/modal/usePortal";
import { PortalID } from "frontend/modal/portal-types";

export default function Toast({
  text,
  trigger,
  onExitCallback,
}: {
  text: string;
  trigger: boolean;
  onExitCallback?: () => void;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const target = usePortal(PortalID.ErrorPage);

  useEffect(() => {
    if (trigger) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        onExitCallback && onExitCallback();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [trigger]);

  if (!isVisible) return null;

  return renderInPortal(
    target,
    <div className={style.container}>
      <div className={style.content}>{text}</div>
    </div>
  );
}
